// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1396E","toggleWrap":"styles_toggleWrap__2W-Qj","content":"styles_content__3amLU","selectAreaCode":"styles_selectAreaCode__1je-Y"};